const getMoreMovies = (movieData, movies, technologyAttributesWithIcons, technologyAttributesWithoutIcons)  => {
    const technologyAttributesWithIconsWithout2D = _.reject(technologyAttributesWithIcons, attribute => {
        return attribute.id.toLowerCase() === '2d'
    })

    if(technologyAttributesWithoutIcons.length !== 0) {
        const technologyItem = technologyAttributesWithoutIcons[Math.floor(Math.random()*technologyAttributesWithoutIcons.length)];
        const choosenMovies = _.filter(movies, movie => {
            return _.find(movie.technologyAttributes, attr => {
                return attr.id === technologyItem.id && movie.pk !== movieData.pk
            })
        })

        _.shuffle(choosenMovies)
        choosenMovies.splice(4)
        
        return choosenMovies

    } else if (technologyAttributesWithIconsWithout2D.length !== 0) {
        const technologyItem = technologyAttributesWithIconsWithout2D[Math.floor(Math.random()*technologyAttributesWithIconsWithout2D.length)];
        const choosenMovies = _.filter(movies, movie => {
            return _.find(movie.technologyAttributes, attr => {
                return attr.id === technologyItem.id && movie.pk !== movieData.pk
            })
        })

        _.shuffle(choosenMovies)
        choosenMovies.splice(4)
        
        return choosenMovies
        
    } else if (movieData.genres.length !== 0) {
        const genreItem = movieData.genres[Math.floor(Math.random()*movieData.genres.length)];
        const choosenMovies = _.filter(movies, movie => {
            return _.find(movie.genres, genre => {
                return genre === genreItem && movie.pk !== movieData.pk
            })
        })

        _.shuffle(choosenMovies)
        choosenMovies.splice(4)
        
        return choosenMovies
        
        
    } else {
        const choosenMovies = _.shuffle(_.values(movies))
        choosenMovies.splice(4)

        return choosenMovies
    }
}

export default getMoreMovies